// Nombres de archivo van a rutas de storage y a Content-Disposition del backend:
// solo letras, numeros, guion y guion bajo evitan problemas de encoding/paths ahi.
const INVALID_FILE_NAME_CHARS = /[^a-zA-Z0-9_-]/g

export const sanitizeFileName = (value) => (value || "").replace(INVALID_FILE_NAME_CHARS, "")

export const FILE_NAME_HELP_TEXT =
  "Solo letras, números, guiones (-) y guiones bajos (_). No se permiten espacios ni otros caracteres especiales. Nombre de archivo Ej. sucursal-completo-20260801"
